import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Layout from './components/Layout/Layout';
import PublicLayout from './components/Layout/PublicLayout';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import './components/GeosMap/GISStyles.css';

// Pages
import Home from './pages/Home/Home';
import Login from './pages/Auth/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import UserManagement from './pages/Admin/UserManagement';
import WorkflowConfig from './pages/Admin/WorkflowConfig';
import DistrictManagement from './pages/Admin/DistrictManagement';
import Reports from './pages/Reports/Reports';
import GeospatialReport from './pages/GeospatialReport/GeospatialReport';
import Profile from './pages/Profile/Profile';
// import ApplicationDetails from './pages/Applications/ApplicationDetails';
// import ApplicationsList from './pages/Applications/ApplicationsList';

// Application Components
import ExgratiaApplicationForm from './components/Applications/ExgratiaApplicationForm';
import ApplicationsList from './components/Applications/ApplicationsList';
import InspectionReportList from './components/Applications/InspectionReportList';
import ApplicationDetails from './components/Applications/ApplicationDetails';

function App() {
  const { isAuthenticated } = useSelector((state) => state.auth);

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route 
          path="/home" 
          element={
            <PublicLayout>
              <Home />
            </PublicLayout>
          } 
        />
        <Route 
          path="/login" 
          element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />} 
        />
        
        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="applications">
            <Route index element={<ApplicationsList />} />
            <Route path=":listtype" element={<ApplicationsList />} />
            <Route 
              path="apply" 
              element={
                <ProtectedRoute allowedRoles={['admin', 'l1_staff', 'citizen']}>
                  <ExgratiaApplicationForm />
                </ProtectedRoute>
              } 
            />
            <Route path="details/:id" element={<ApplicationDetails />} />
            <Route 
              path="edit/:refno" 
              element={
                <ProtectedRoute allowedRoles={['admin', 'l1_staff', 'citizen']}>
                  <ExgratiaApplicationForm />
                </ProtectedRoute>
              } 
            />
          </Route>
          <Route path="inspections">
            <Route 
              path="new-requests" 
              element={
                <ProtectedRoute allowedRoles={['reve_o', 'ahvs_h', 'agri_h', 'horti_h']}>
                  <InspectionReportList />
                </ProtectedRoute>
              }
            />
            <Route 
              path="all-assigned-requests/:type" 
              element={
                <ProtectedRoute allowedRoles={['reve_o', 'ahvs_h', 'agri_h', 'horti_h']}>
                  <InspectionReportList />
                </ProtectedRoute>
              }
            />
            <Route 
              path="assigned-requests/head" 
              element={
                <ProtectedRoute allowedRoles={['reve_o', 'ahvs_h', 'agri_h', 'horti_h']}>
                  <InspectionReportList />
                </ProtectedRoute>
              }
            />
            <Route 
              path="pending-inspections" 
              element={
                <ProtectedRoute allowedRoles={['reve_i', 'ahvs_i', 'agri_i', 'horti_i']}>
                  <InspectionReportList />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="my-reports" 
              element={
                <ProtectedRoute allowedRoles={['reve_i', 'ahvs_i', 'agri_i', 'horti_i']}>
                  <InspectionReportList />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="pending-reports" 
              element={
                <ProtectedRoute allowedRoles={['reve_o', 'ahvs_h', 'agri_h', 'horti_h']}>
                  <InspectionReportList />
                </ProtectedRoute>
              }
            />
            <Route 
              path="unverified-reports" 
              element={
                <ProtectedRoute allowedRoles={['reve_o', 'ahvs_h', 'agri_h', 'horti_h']}>
                  <InspectionReportList />
                </ProtectedRoute>
              }
            />
            <Route 
              path="verified-reports" 
              element={
                <ProtectedRoute allowedRoles={['reve_o', 'ahvs_h', 'agri_h', 'horti_h']}>
                  <InspectionReportList />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route 
            path="reports" 
            element={
              <ProtectedRoute allowedRoles={['admin', 'l1_staff', 'dc', 'dpo', 'sdm']}>
                <Reports />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="geospatial-report" 
            element={
              <ProtectedRoute allowedRoles={['admin', 'l1_staff', 'dc', 'dpo', 'sdm', 'reve_o', 'ahvs_h', 'agri_h', 'horti_h']}>
                <GeospatialReport />
              </ProtectedRoute>
            } 
          />
          <Route path="profile" element={<Profile />} />
          
          {/* Admin Routes */}
          <Route path="admin">
            <Route 
              path="users" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <UserManagement />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="workflow" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <WorkflowConfig />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="districts" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <DistrictManagement />
                </ProtectedRoute>
              } 
            />
          </Route>
        </Route>

        {/* Fallback route */}
        <Route 
          path="*" 
          element={<Navigate to={isAuthenticated ? "/dashboard" : "/home"} replace />} 
        />
      </Routes>
    </Router>
  );
}

export default App;
